/* eslint-disable  */

import { translate } from '@/domains/core/localization/translate';
export const {
  tabsContainerDetails,
  tabsContainerReviews,
  tabsContainerInformations,
  tabsContainerBackBtn
} = translate({
  "tabsContainerDetails": "Details",
  "tabsContainerReviews": "Reviews",
  "tabsContainerInformations": "Information",
  "tabsContainerBackBtn": "Go back to the product sheet"
});